import { MatTable } from '@angular/material/table';
import { DatosToggle, Job } from './../../tech-admin.models';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Alert } from '@app/tech-admin/tech-admin.models';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  sortedData: any[];

  constructor() {
    this.sortedData = this.dataSourceInput.slice();
  }

  @Input() dataSourceInput: any[] = [];

  @Input() displayedColumns: string[] = [];

  @Input() nameTab: string = '';

  @Output() onChangeToggleEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(MatTable) table: MatTable<any>;

  ngOnInit(): void {}

  onChangeToggle(statusSwitch: boolean, nameAlert: string) {
    let datosToggle: DatosToggle = {
      statusSwitch: statusSwitch,
      nameAlert: nameAlert,
    };
    this.onChangeToggleEmitter.emit(datosToggle);
  }

  onOrder(sort: Sort) {
    console.log('Antes');
    console.log(this.dataSourceInput);
    const data = this.dataSourceInput.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return this.compare(a.name, b.name, isAsc);
        case 'firstTimeCrashReported':
          return this.compare(a.firstTimeCrashReported, b.firstTimeCrashReported, isAsc);
        case 'numTimes':
          return this.compare(a.numTimes, b.numTimes, isAsc);
        case 'maxAllowed':
          return this.compare(a.maxAllowed, b.maxAllowed, isAsc);
        case 'secondsPeriodAllowed':
          return this.compare(a.secondsPeriodAllowed, b.secondsPeriodAllowed, isAsc);
        case 'ruleType':
          return this.compare(a.ruleType, b.ruleType, isAsc);
        case 'jobName':
          return this.compare(a.jobName, b.jobName, isAsc);
        default:
          return 0;
      }
    });
    this.dataSourceInput = this.sortedData;
    //necesario para ver cambios
    this.table.renderRows();

    console.log('despues');
    console.log(this.dataSourceInput);
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
